import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { LangText } from '@/components'
import { preFixImgUrl } from '@/utils'
import useModel, { type QuickLinkItem } from './useModel'
import { SparkleTitle } from '../HanedaShop'

export const TITLE_GRADIENT = 'bg-linear-to-r from-[#4B51FF] to-[#A75AFF] bg-clip-text text-transparent'

const SagawaExp = () => {
  const { t } = useTranslation()
  const { benefitCards, howToScreens, quickLinks } = useModel()

  return (
    <div className="bg-[#F8F6FF]">
      {/* Hero */}
      <div
        className="relative min-h-[480px] flex flex-col items-center justify-center px-6 py-20 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${preFixImgUrl('e74884796e3af78a95c207b2e52f29ff.png')})` }}
      >
        <div className="flex relative z-10 flex-col items-center mx-auto max-w-3xl text-center">
          <LangText lngKey="57e322d7" className="text-white text-[40px] md:text-[44px] font-bold leading-tight px-2">
            {t('57e322d7')}
          </LangText>
          <LangText lngKey="c6831487" className="text-white text-[17px] md:text-[18px] leading-relaxed mt-6 px-2">
            {t('c6831487')}
          </LangText>
          <div className="flex flex-wrap gap-5 justify-center mt-10">
            {/* <OutLink platform={PlatformEnum.SGW}> */}
              <div
                className="h-[48px] min-w-[140px] px-10 flex items-center justify-center rounded-full text-white text-[17px] cursor-pointer transition-opacity hover:opacity-90"
                style={{ background: 'linear-gradient(270deg, #A75AFF 0%, #4B51FF 100%)' }}
                onClick={() => window.open('https://m.ctrip.com/webapp/you/gsshopping/shops/2/0.html?seo=0&ishidenavbar=yes&poiId=154106803&share=1&bid=8&pid=6&cid=600083&openapp=3&wxpopup=205&inpopup=true&open_in_browser=true')}
              >
                <LangText lngKey="ad8b9d1b">{t('ad8b9d1b')}</LangText>
              </div>
            {/* </OutLink> */}
          </div>
        </div>
      </div>

      {/* 价值主张 */}
      <section className="py-[60px]">
        <div className="px-16 mx-auto w-8xl">
          <SparkleTitle lngKey="78da76b9" purpleTitle />
          <div className="grid grid-cols-4 gap-y-12 gap-x-24 mt-4">
            {benefitCards.map(({ img, titleKey, descKey }) => (
              <div key={titleKey} className="flex flex-col items-center text-center">
                <div className="rounded-2xl flex items-center justify-center p-4 min-h-[200px] w-full max-w-[280px] mx-auto">
                  <img src={img} alt="" className="w-full max-h-[220px] object-contain object-center" />
                </div>
                <LangText lngKey={titleKey} className={`inline-block mt-4 font-bold text-[18px] ${TITLE_GRADIENT}`}>
                  {t(titleKey)}
                </LangText>
                <LangText
                  lngKey={descKey}
                  className="text-[15px] text-[#333333] mt-3 leading-relaxed max-w-[280px] whitespace-pre-line"
                >
                  {t(descKey)}
                </LangText>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 如何使用 */}
      <section className="mt-[10px] pb-[40px] md:pb-[60px]">
        <div className="px-6 mx-auto w-8xl md:px-10">
          <SparkleTitle lngKey="c7cd81b5" purpleTitle />
          <div className="mt-10 mb-8 rounded-[28px] bg-white shadow-[0_8px_40px_rgba(0,0,0,0.08)] px-6 py-10 md:px-12 md:py-14">
            <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
              {howToScreens.map((item) => (
                <div key={item.titleKey} className="flex flex-col items-center text-center">
                  <div className="w-full max-w-[200px] mx-auto">
                    <img src={item.img} alt="" className="object-cover w-full h-auto rounded-xl" />
                  </div>
                  <LangText
                    lngKey={item.titleKey}
                    className={`mt-6 font-bold leading-snug text-[16px] md:text-[17px] ${TITLE_GRADIENT}`}
                  >
                    {t(item.titleKey)}
                  </LangText>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 二次 CTA */}
      <div
        className="relative min-h-[360px] flex flex-col items-center justify-center px-6 py-16 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${preFixImgUrl('5ff5d7077ad1a4ea2dcf9d657fdd79cc.png')})` }}
      >
        <div className="flex relative z-10 flex-col items-center text-center">
          <LangText lngKey="26db8846" className="text-white text-[40px] font-bold opacity-95">
            {t('26db8846')}
          </LangText>
          <LangText lngKey="63829f9b" className="text-white text-[26px] font-normal mt-4 leading-tight">
            {t('63829f9b')}
          </LangText>
          {/* <OutLink platform={PlatformEnum.SGW}> */}
            <div
              className="h-[52px] min-w-[200px] mt-10 px-10 flex items-center justify-center rounded-full text-white text-[18px] cursor-pointer transition-opacity hover:opacity-90"
              style={{ background: 'linear-gradient(270deg, #A75AFF 0%, #4B51FF 100%)' }}
              onClick={() => window.open('https://m.ctrip.com/webapp/you/gsshopping/shops/2/0.html?seo=0&ishidenavbar=yes&poiId=154106803&share=1&bid=8&pid=6&cid=600083&openapp=3&wxpopup=205&inpopup=true&open_in_browser=true')}
            >
              <LangText lngKey="bcc799b1">{t('bcc799b1')}</LangText>
            </div>
          {/* </OutLink> */}
        </div>
      </div>

      {/* 快捷入口：用户条款 /items，注意事项与常见问题独立页，联系我们 mailto */}
      <section className="pt-12 pb-16">
        <div className="px-6 mx-auto w-8xl md:px-10">
          <div className="grid grid-cols-2 gap-3 w-full sm:grid-cols-4 sm:gap-4 md:gap-6">
            {quickLinks.map((item: QuickLinkItem) => {
              const cardClass =
                'flex flex-col gap-4 items-center min-w-0 text-center cursor-pointer transition-opacity hover:opacity-90 text-inherit no-underline'
              const inner = (
                <>
                  <span className="w-[88px] h-[88px] flex items-center justify-center">
                    <img src={item.iconImg} alt="" className="object-contain max-w-full max-h-full" />
                  </span>
                  <LangText lngKey={item.key} className="text-[18px] text-[#333333] font-bold">
                    {t(item.key)}
                  </LangText>
                </>
              )
              if ('href' in item) {
                return (
                  <a
                    key={item.key}
                    href={item.href}
                    {...(item.openInNewTab
                      ? { target: '_blank', rel: 'noopener noreferrer' }
                      : {})}
                    className={cardClass}
                  >
                    {inner}
                  </a>
                )
              }
              return (
                <Link key={item.key} to={item.to} className={cardClass}>
                  {inner}
                </Link>
              )
            })}
          </div>
        </div>
      </section>
    </div>
  )
}

export default SagawaExp
